export class GcpEncryptionKey {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpEncryptionKey.attributeTypeMap;
    }
    constructor() {
    }
}
